import PropTypes from 'prop-types';

const OrderType = PropTypes.shape({
  id: PropTypes.number,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  brand: PropTypes.string,
  last_four: PropTypes.string,
  state: PropTypes.string,
  description: PropTypes.string,
  entity_id: PropTypes.string,
  entity_class: PropTypes.string,
  payment_method: PropTypes.string,
  raw_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  base_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  convenience_fee: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

export default OrderType;
